<template>
	<div class="element-box p-0">
		<div class="head">
			<h2>{{ t.user.forgot_password }}</h2>
		</div>
		<div class="element-content reginstration-form  px-5 pb-5">
			<div v-if="result" v-html="result">

			</div>
			<symForm :options="opt" :data="formData" v-on:sended="setForm" :form="userForm" :formProcess="formProcess" v-if="userForm" />
		</div>
	</div>
</template>

<script>

    import symForm from '@/components/form/symForm.vue'
    import globalLoader from '@/components/ui/loader/globalLoader.vue'
    import Login from '@/components/auth/Login.vue'

    export default {
        name: 'Resetting',
        components: { symForm, globalLoader, Login },
        data () {
            return {
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                regions: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                opt: {
                    username: {data: [], label: 'username'},
                },
                formData: [],
	            result: null
            }
        },
        mounted () {
            this.getUserForm();
        },
        notifications: {
            showFormError: { // You can have any name you want instead of 'showLoginError'
                title: 'Login Failed',
                message: 'Failed to authenticate',
                type: 'error' // You also can use 'VueNotifications.types.error' instead of 'error'
            }
        },
        methods: {
            async getUserForm (data) {


                this.userForm = null;
                this.formProcess = 0;
                this.$bus.$emit('globalLoader', 1);
                if(data) {

                } else {
                    this.$http.get(api+'api/v1/auth/resetting/request')
                        .then(response => {

                            this.userForm = response.body;
                            this.formData = {username: ''  };
                            this.$bus.$emit('globalLoader', 0);

                        }, response => {
                            this.$bus.$emit('globalLoader', 0);
                        })
                }

            },

	        async setForm (data) {
                //this.userForm = null;
                this.$http.post(api+'api/v1/auth/resetting/send-email',
                    data )
                    .then(response => {

                        this.result = response.body;
                        this.formProcess = 200;

                        //swal('', this.t.registration.success, "success")
                        this.$bus.$emit('globalLoader', 0);

                    }, response => {
                        this.userForm = response.body;
                        this.formProcess = 400;
                        swal(this.t.processing.error, this.t.processing.check, "error")
                        this.$bus.$emit('globalLoader', 0);
                    })

            },
            redirectHome () {
                window.location.href = '/';
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

	.reginstration-form .form-group {
		float: left !important;
		width: 50% !important;
		height: auto;
		padding: 5px;
    align-items: center;
	}

	#fos_user_registration_form_mobilePhone_number {
		width: 100%;
	}

</style>



// WEBPACK FOOTER //
// src/components/user/form/resetting.vue